(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["full-face-photo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('full-face-photo')) {
  const loadedPhotos = new Map();
  function loadPhoto(source) {
    if (!loadedPhotos.has(source)) {
      loadedPhotos.set(source, new Promise((resolve, reject) => {
        const img = new Image();
        const timer = setTimeout(() => reject(new Error('timeout')), 15000);
        img.onload = () => { clearTimeout(timer); resolve(); };
        img.onerror = () => { clearTimeout(timer); reject(new Error('image')); };
        img.src = source;
      }).catch(error => { loadedPhotos.delete(source); throw error; }));
    }
    return loadedPhotos.get(source);
  }
  customElements.define('full-face-photo', class extends HTMLElement {
    connectedCallback() {
      if (this.handler) return;
      const mapping = this.querySelector('[data-photo-sources]');
      if (!mapping) return;
      this.sources = JSON.parse(mapping.textContent);
      this.blushImage = this.querySelector('.full-face-photo__blush');
      this.highlighterImage = this.querySelector('.full-face-photo__highlighter');
      this.loading = this.querySelector('.full-face-photo__loading');
      this.error = this.querySelector('.full-face-photo__error');
      this.version = 0;
      this.handler = event => {
        const section = document.getElementById('MainProduct-' + this.dataset.section);
        if (!section || !section.contains(event.target)) return;
        const picker = event.target.closest('variant-radios, variant-selects');
        if (!picker) return;
        const selected = picker.matches('variant-radios')
          ? Array.from(picker.querySelectorAll('fieldset input:checked'), input => input.value)
          : Array.from(picker.querySelectorAll('select'), select => select.value);
        if (selected.length === 2) this.updatePhoto(selected[0], selected[1]);
      };
      document.addEventListener('change', this.handler);
    }
    disconnectedCallback() {
      document.removeEventListener('change', this.handler);
      this.handler = null;
      this.version++;
    }
    async updatePhoto(blush, highlighter) {
      const version = ++this.version;
      const blushSource = this.sources.blush[blush];
      const highlighterSource = this.sources.highlighter[highlighter];
      this.error.hidden = true;
      this.loading.hidden = false;
      this.setAttribute('aria-busy', 'true');
      try {
        if (!blushSource || !highlighterSource) throw new Error('unmapped');
        await Promise.all([loadPhoto(blushSource), loadPhoto(highlighterSource)]);
        if (version !== this.version || !this.isConnected) return;
        this.blushImage.src = blushSource;
        this.highlighterImage.src = highlighterSource;
        this.dataset.blush = blush;
        this.dataset.highlighter = highlighter;
        this.setAttribute('aria-label', this.dataset.productTitle + ' — ' + blush + ' / ' + highlighter);
      } catch (error) {
        if (version === this.version) this.error.hidden = false;
      } finally {
        if (version === this.version) {
          this.loading.hidden = true;
          this.removeAttribute('aria-busy');
        }
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["highlighter-signup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('highlighter-signup')) {
  let signupSequence = 0;
  customElements.define('highlighter-signup', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.toggle = this.querySelector('[data-signup-toggle]');
      this.panel = this.querySelector('.highlighter-signup__panel');
      this.form = this.querySelector('form');
      if (!this.toggle || !this.panel || !this.form) return;
      this.initialized = true;
      this.email = this.form.elements.email;
      this.submitButton = this.querySelector('[data-signup-submit]');
      this.error = this.querySelector('.highlighter-signup__error');
      this.success = this.querySelector('.highlighter-signup__success');
      this.intro = this.querySelector('.highlighter-signup__intro');
      this.panel.id = 'highlighter-signup-panel-' + (++signupSequence);
      this.toggle.setAttribute('aria-controls', this.panel.id);
      this.toggle.setAttribute('aria-haspopup', 'dialog');
      this.toggle.disabled = false;
      this.toggle.addEventListener('click', () => this.setOpen(this.panel.hidden));
      this.querySelector('.highlighter-signup__dismiss').addEventListener('click', () => this.setOpen(false));
      this.panel.addEventListener('cancel', event => {
        event.preventDefault();
        this.setOpen(false);
      });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !this.panel.hidden) {
          event.preventDefault();
          this.setOpen(false);
        }
      });
      this.form.addEventListener('submit', event => this.subscribe(event));
    }
    setOpen(open) {
      if (open) {
        this.panel.hidden = false;
        if (!this.panel.open) this.panel.showModal();
        document.documentElement.classList.add('highlighter-signup-modal-open');
      } else {
        this.panel.close();
        this.panel.hidden = true;
        if (!document.querySelector('dialog.highlighter-signup__panel[open]')) document.documentElement.classList.remove('highlighter-signup-modal-open');
      }
      this.toggle.setAttribute('aria-expanded', String(open));
      if (open) (this.success.hidden ? this.email : this.success).focus({ preventScroll:true });
      else this.toggle.focus({ preventScroll:true });
    }
    disconnectedCallback() {
      if (this.panel && this.panel.open) this.panel.close();
      if (!document.querySelector('dialog.highlighter-signup__panel[open]')) document.documentElement.classList.remove('highlighter-signup-modal-open');
    }
    async subscribe(event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.pending || !this.form.reportValidity()) return;
      this.pending = true;
      this.submitButton.disabled = true;
      this.form.setAttribute('aria-busy', 'true');
      this.error.hidden = true;
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const registration = new URL(this.dataset.registrationUrl);
        const company = registration.searchParams.get('a');
        const list = registration.searchParams.get('g');
        if (registration.hostname !== 'manage.kmail-lists.com' || !company || !list) throw new Error('configuration');
        const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
          method:'POST',
          headers:{'Content-Type':'application/vnd.api+json', 'Accept':'application/vnd.api+json', 'revision':'2026-07-15'},
          credentials:'omit',
          signal:controller.signal,
          body:JSON.stringify({data:{type:'subscription', attributes:{custom_source:'Painted Highlighter launch inline registration', profile:{data:{type:'profile', attributes:{email:this.email.value.trim(), subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}}}}}, relationships:{list:{data:{type:'list', id:list}}}}})
        });
        if (response.status !== 202) throw new Error(response.status === 429 ? 'rate' : 'request');
        this.form.hidden = true;
        this.intro.hidden = true;
        this.form.reset();
        this.success.hidden = false;
        if (!this.panel.hidden) this.success.focus({ preventScroll:true });
      } catch (error) {
        this.error.textContent = error.message === 'rate' ? this.dataset.rateError : this.dataset.error;
        this.error.hidden = false;
      } finally {
        clearTimeout(timeout);
        this.pending = false;
        this.submitButton.disabled = false;
        this.form.removeAttribute('aria-busy');
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
